:host {
  display: block;
}

.dynamic-ymm-entry-example-text {
  font-family: var(--typography-dynamic-entry-heading);
}
